import "https://cdnjs.cloudflare.com/ajax/libs/ace/1.39.0/ace.min.js"
// import "https://cdnjs.cloudflare.com/ajax/libs/ace/1.39.0/mode-ruby.min.js"
// import "https://cdnjs.cloudflare.com/ajax/libs/ace/1.39.0/mode-yaml.min.js"
// import "https://cdnjs.cloudflare.com/ajax/libs/ace/1.39.0/theme-monokai.min.js"

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input", "code"
  ];

  static values = {
    language: String
  }

  connect() {
    // this.element.textContent = "Hello Ace s!"
    ace.config.set('basePath', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.39.0')

    let extLang
    if (this.languageValue == 'html')
      extLang = "ace/mode/html"
    else if (this.languageValue == 'css')
      extLang = "ace/mode/css"
    else if (this.languageValue == 'markdown')
      extLang = "ace/mode/markdown"
    else if (this.languageValue == 'yaml')
      extLang = "ace/mode/yaml"
    else if (this.languageValue == 'ruby')
      extLang = "ace/mode/ruby"

    var editor = ace.edit(this.codeTarget)
    // editor.setTheme("ace/theme/monokai-light")

    console.log('extLang', extLang)
    editor.session.setMode(extLang)
    editor.session.setOptions({ tabSize: 2, useSoftTabs: true });

    editor.session.setValue(this.inputTarget.value);

    editor.session.on('change', (delta) => {
      // delta.start, delta.end, delta.lines, delta.action
      const val = editor.session.getValue()
      console.log('val', val)
      this.inputTarget.value = editor.session.getValue();
    });

  }
}
